import { safeInternalPath } from "./safeInternalPath";

export const LOGIN_SETUP_PASSKEY_PATH = "/login/setup-passkey";

/**
 * Build a URL to the passkey setup step, carrying `redirect` for the final
 * destination. If `redirect` already points at the setup page, its inner
 * `redirect` param is preserved instead of double-wrapping.
 */
export function buildLoginSetupPasskeyUrl(
  redirect: string | null | undefined,
): string {
  const next = unwrapRedirect(redirect);
  return `${LOGIN_SETUP_PASSKEY_PATH}?${new URLSearchParams({ redirect: next }).toString()}`;
}

function unwrapRedirect(value: string | null | undefined): string {
  const candidate = safeInternalPath(value, "/dashboard");
  if (!candidate.startsWith(LOGIN_SETUP_PASSKEY_PATH)) {
    return candidate;
  }
  const queryIndex = candidate.indexOf("?");
  if (queryIndex < 0) {
    return "/dashboard";
  }
  const inner = new URLSearchParams(candidate.slice(queryIndex + 1)).get(
    "redirect",
  );
  return safeInternalPath(inner, "/dashboard");
}
